import { CheckCircle2, XCircle } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";

export function OfferLoadingScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="p-12 text-center">
          <div className="animate-pulse space-y-4">
            <div className="h-8 bg-muted rounded w-3/4 mx-auto" />
            <div className="h-4 bg-muted rounded w-1/2 mx-auto" />
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

export function OfferNotFoundScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="p-12 text-center">
          <h2 className="text-2xl font-semibold mb-2">Oferta não encontrada</h2>
          <p className="text-muted-foreground">Este link de oferta é inválido ou expirou.</p>
        </CardContent>
      </Card>
    </div>
  );
}

export function OfferAcceptedScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="p-12 text-center">
          <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-emerald-100 dark:bg-emerald-900/30">
            <CheckCircle2 className="h-8 w-8 text-emerald-600 dark:text-emerald-400" />
          </div>
          <h2 className="text-2xl font-semibold mb-2">Bem-vindo à equipe!</h2>
          <p className="text-muted-foreground mb-4">
            Sua oferta foi aceita. Estamos animados para tê-lo conosco!
          </p>
          <p className="text-sm text-muted-foreground">
            Você receberá as instruções de onboarding em breve.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}

export function OfferDeclinedScreen() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <Card className="w-full max-w-lg">
        <CardContent className="p-12 text-center">
          <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-full bg-muted">
            <XCircle className="h-8 w-8 text-muted-foreground" />
          </div>
          <h2 className="text-2xl font-semibold mb-2">Oferta recusada</h2>
          <p className="text-muted-foreground">
            Agradecemos seu interesse. Desejamos sucesso em sua jornada!
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
